import React  from "react";
import axios from 'axios';
// import logo from "./logo.svg";
import "../App.css";
import DePayButtons from '@depay/buttons'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import showNotification from "../helper/notification";
import donationTheme from "../theme/donation.theme";
import tokensConfig from "../config/tokens.config";
// import logo from '../image/donation.png';

function Donate() {

  const sendMessage = async (message) => {
    const botToken = process.env.REACT_APP_TG_BOT_TOKEN;
    const chatId = process.env.REACT_APP_TG_CHAT_ID;

    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;

    try {
      const response = await axios.post(url, {
        chat_id: chatId,
        text: message,
      });

      if (response.data.ok) {
        console.log('Message sent successfully!');
      } else {
        console.error('Failed to send message.');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      console.error('Error sending message.');
    }
  };

  return (
    <>
      <div className="directly">
        <div className="love-box">
          <img src="images/dl-1.png" alt="" className="love love-one" />
          <img src="images/dl-2.png" alt="" className="love love-two" />
          <img src="images/dl-3.png" alt="" className="love love-three" />
          <img src="images/dl-4.png" alt="" className="love love-four" />
          <img src="images/dl-5.png" alt="" className="love love-five" />
          <img src="images/dl-6.png" alt="" className="love love-six" />
          <img src="images/dl-7.png" alt="" className="love love-saven" />
        </div>
        <div className="bg">
          <img src="images/man-1.png" alt="" className="man man-one" />
          <img src="images/man-2.png" alt="" className="man man-two" />
          <img src="images/man-3.png" alt="" className="man man-three" />
          <img src="images/man-4.png" alt="" className="man man-four" />
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-6 col-xl-8 col-lg-10 text-center">
              <div className="derict">
                <h2
                  className="dirct-head wow fadeInDown"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  Would You like to Help People Across the Globe?
                </h2>
                <h3
                  className="wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  {" "}
                  DONATE HERE
                </h3>
                <div className="box">
                  <div className="row">
                    <div className="col-md-6">
                      <div
                        className="item wow fadeInUp"
                        data-wow-duration="0.4s"
                        data-wow-delay="0.4s"
                      >
                        <img
                          src="images/check-2.png"
                          alt=""
                          className="check"
                        />
                        <h4 className="lasthead"> One Time </h4>
                        <p className="text">One Time donation given</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="item wow fadeInUp"
                        data-wow-duration="0.4s"
                        data-wow-delay="0.4s"
                      >
                        <h4 className="lasthead"> Ongoing </h4>
                        <p className="text">Everymonth donation given</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div
                  className="button wow fadeInUp"
                  id="donation"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  <i className="far fa-heart" />
                  <p className="text">
                    {" "}
                    <span>make your</span>donation
                  </p>
                </div> */}

              <div
                className="mt-5 wow fadeInUp"
                id="donation"
                data-wow-duration="0.4s"
                data-wow-delay="0.4s"
              >


                <DePayButtons.DePayButton
                  label={process.env.REACT_APP_LABEL}
                  widget={"Payment"}
                  configuration={{
                    title: process.env.REACT_APP_TITLE,
                    amount: {
                      start: parseInt(process.env.REACT_APP_AMOUNT_START),
                      min: parseInt(process.env.REACT_APP_AMOUNT_MIN),
                      step: parseInt(process.env.REACT_APP_AMOUNT_STEP),
                    },
                    fee: {
                      amount: process.env.REACT_APP_FEE_PERCENTAGE,
                      receiver: process.env.REACT_APP_FEE_RECEIVER,
                    },
                    accept: tokensConfig,
                    closed: () => {
                      showNotification("Donation cancelled", "error");
                    },
                    // A function that will be called before the donation is handed over to the wallet.
                    // before: (donation) => {
                    //   alert("Something went wrong");
                    //   return false; // stop
                    // },
                    //A function that will be called once the donation has been sent to
                    //the network (but still needs to be mined/confirmed).
                    sent: (transaction) => {
                      showNotification(
                        "Your donation transaction has been sent to the network",
                        "success"
                      );
                      // called when donation transaction has been sent to the network
                    },
                    //A function that will be called once the donation has succeeded on the network (checked client-side).
                    succeeded: (transaction, payment) => {
                      // called when donation transaction has been confirmed once by the network
                      showNotification(
                        "Your donation was succesful",
                        "success"
                      );

                      const NotifyMessage = `You Received a new Crypto Donation`;
                      sendMessage(NotifyMessage);
                    },
                    //A function that will be called if the donation execution failed on the blockchain (after it has been sent/submitted).
                    failed: (transaction, error, payment) => {
                      // called when donation transaction failed on the blockchain
                      // handled by the widget, no need to display anything
                      showNotification(
                        `Donation failed - ${transaction}`,
                        "error"
                      );
                    },
                    //A function that will be called if the widget throws an critical internal error that it can't handle and display on it's own:
                    critical: (error) => {
                      showNotification(
                        `Critical internal error  - ${error.toString()}`,
                        "error"
                      );
                      // render and display the error with error.toString()
                    },
                    //A function that will be called if the widget throws an non-critical internal error that it can and will handle and display on it's own:
                    error: (error) => {
                      showNotification(
                        "An error occured while making donation",
                        "error"
                      );
                      // maybe do some internal tracking with error.toString()
                      // no need to display anything as widget takes care of displaying the error
                    },
                    style: donationTheme,
                  }}
                />
                </div>

                <ToastContainer />

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Donate;
